export const GENERIC_INVALID_CREDENTIALS_MSG = 'Double-check your credentials and please try again. If the issue continues, contact support.';
